import FontKitImage from 'assets/images/font_kit.png';
import { UPGRADE_REDIRECT_BIZ_LINK } from 'constants/links';
import { UPGRADE } from 'constants/mixpanel';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';
import { CommonGatedUpgradeModal } from 'modules/Editor/components/Modals/CommonGatedUpgradeModal';
import { ModalUpgradeTypeEnum } from 'modules/Editor/components/Modals/CommonGatedUpgradeModal.types';
import { useAppDispatch, useAppSelector } from 'modules/Editor/store';
import { selectIsGatedFontUploadModalOpen } from 'modules/Editor/store/editorSettingsSelector';
import { setIsGatedFontUploadModalOpen } from 'modules/Editor/store/editorSettingsSlice';
import { UserTypes } from 'modules/User';
import { setAnalyticsUpgradeFeatureProp } from 'utils/sessionStorage';

export const GatedFontUploadModal = () => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(selectIsGatedFontUploadModalOpen);

  const onUpgradeClick = () => {
    Mixpanel.track(UPGRADE.eventName, {
      feature: UPGRADE.feature.CustomFont,
    });

    setAnalyticsUpgradeFeatureProp(UPGRADE.feature.CustomFont);
    window.open(UPGRADE_REDIRECT_BIZ_LINK, '_self');
  };

  const onCloseUpgradeModal = () => {
    dispatch(setIsGatedFontUploadModalOpen(false));
  };

  return (
    <CommonGatedUpgradeModal
      modalType={ModalUpgradeTypeEnum.FontKit}
      isOpen={isOpen}
      modalImg={FontKitImage}
      onClickUpgrade={onUpgradeClick}
      onClose={onCloseUpgradeModal}
      upgradePlan={UserTypes.Business}
      modalContentProps={{ zIndex: 'tooltip' }} // define a higher zIndex compared to popover
    />
  );
};

GatedFontUploadModal.displayName = 'FontKitUpgradeModal';
